import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logDesktopPermissionsModalState(isOpen: boolean) {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.MicCamPermissionPrompt,
    actionScenarioType: ScenarioType.Initialization,
    actionGesture: ActionGesture.Click,
    actionOutcome: isOpen
      ? PanelActionOutcome.OpenDialog
      : PanelActionOutcome.DismissBanner,
    moduleName: ModuleName.DesktopPermissionsPromptModal,
    moduleSummary: isOpen
      ? ModuleSummary.DesktopPermissionsPromptModalOpened
      : ModuleSummary.DesktopPermissionsPromptModalClosed,
    panelType: PanelType.TestResults,
    panelLaunchMethod: PanelLaunchMethod.Update,
    panelRegion: PanelRegion.Modal,
    panelUri: window.location.pathname,
  });
}
